
import { PropType } from 'vue';
import ctrlMixins from './../_mixins.js';
import { UarmCtrlComponent, CardMetaItem, UarmCtrlComponentMeta } from './../../types';
// @ts-ignore
import { ctrlParamsForAll, ctrlProps4All } from './../_common-stuff.ts';
// @ts-ignore
import Geocoder from './geocoder.vue';
// @ts-ignore
import { defaultZoom, defaultCenter, epsg3857toEpsg4326, geomixins, Coords } from './geocommon.ts';

const meta: UarmCtrlComponentMeta = {
	// это наши данные, т.е. вуй при объявлении компонента их не использует
	title: 'Координаты ГИП',
	params: {
		colNameLatitude: {
			name: 'Колонка с широтой (должна быть в АРМ)',
			editType: 'input',
			// paramCustomData: { handlerCodes },
		},
		colNameLongitude: {
			name: 'Колонка с долготой (должна быть в АРМ)',
			editType: 'input',
		},
		// см. types.ts! и _common-stuff.ts!
		selectFieldsFromDatabase: {
			name: 'Поля для поиска по адресу (не работает)',
			tip: 'см. types.ts! и _common-stuff.ts! Список колонок записи, в которых хранится адрес, для того чтобы он был предвбит в поле геокодера карты. <b>Пока у ГИП нет геокодера, не работает</b>',
			editType: 'selectFieldsFromDatabase',
			multiple: true, // TODO перенести в paramCustomData
		},
		...ctrlParamsForAll,
	},
}

// Vue.extend нельзя! будут ошибки с $attrs и $listeners
export default {
	name: 'ctrl_geo_single',
	mixins: [ ctrlMixins, geomixins ], // c_value, c_ctrlParams, c_srv_options, пропсы view_type, field_meta и так далее
	// props: { ...ctrlProps4All },
	props: {
		/** Все поля данного АРМ в карточке, со значениями */
		card_meta: {
			type: Array as PropType<CardMetaItem[]>,
			default: () => ([]),
		},
		/** Все поля данного АРМ в карточке, со значениями */
		field_meta: {
			type: Object as PropType<CardMetaItem>,
			default: () => ({}),
		},
	},
	components: { Geocoder },
	meta,
	data: function () {
		const { ctrlParams } = this.$props.field_meta as CardMetaItem;
		const card_meta = this.$props.card_meta as CardMetaItem[];

		// Ставим точку у нас в БД (у нас хранятся в системе координат 4326)
		// Принудительно приводим к намберу, потому что колонки бывают и строковые,
		// а со строковыми координатами ГИП просто намертво виснет
		const latDbcolname = (ctrlParams.colNameLatitude || 'latitude').toLowerCase();
		const longDbcolname = (ctrlParams.colNameLongitude || 'longitude').toLowerCase();
		const latField = card_meta.find(fi => fi.dbcolname.toLowerCase() === latDbcolname);
		const latValue = latField && latField.value ? Number(latField.value) : undefined;
		const longField = card_meta.find(fi => fi.dbcolname.toLowerCase() === longDbcolname);
		const longValue = longField && longField.value ? Number(longField.value) : undefined;

		return {
			errText: '',
			mapId: `mapId-${Math.floor(Math.random() * 1e7)}`,
			latDbcolname,
			longDbcolname,
			latValue,
			longValue,
			geoServiceName: null,
			baseMapName: null,
			geoReadyHappened: false,
			geoApi: null,
		}
	},
	methods: {
		/**
		 * Инициализация карты (собираем конфиг, вешаем события и т.п.)
		 * Запускается из миксина primaryInitMap
		 */
		initMap() {
			// TODO можно ли несколько на одной странице? делать ли копию?
			this.$data.geoApi = window['GeoportalApi']; // cloneDeep(window['GeoportalApi']);
			const { geoApi, mapId, geoServiceName, baseMapName } = this.$data;

			const { latValue, longValue } = this.$data;

			const homeCenter = longValue && latValue ? [longValue, latValue] : defaultCenter; // если точки нет, кажем Москву (координаты указаны в системе координат 4326)

			const config = {
				layersConfig: null, // {defaultLayers: [],requiredLayers: [],mainLayers: [],},
				homeCenter,
				homeZoom: defaultZoom,
				service: geoServiceName || null,
				baseMaps: baseMapName ? [baseMapName] : ['bk_pk_gip'], // gip_conf.base_map
				baseMapsList: ['basemap_rzd', 'bk_pk_gip'],
				workSetFitDisabled: false,
				workSetId: null, // например, 123
				interfaceConfig: { // можно вместо объекта передать налл
					isStatusBarHidden: true,
					isMainToolbarHidden: true,
					// hiddenTools: ['LAYER_LIST', 'MEASURE_CIRCLE'], // массив ключей инструментов, которые будут скрыты в MainToolbar
					isMapToolbarHidden: true, // правая панель
					isZoomHidden: false, // кнопки зума справа
				},
				// interfaceConfig: null,
			};

			// Инициализация геопортала. Передаётся идентификатор элемента и объект конфигурации
			geoApi.init(mapId, config);

			geoApi.ready = () => {
				this.$data.geoReadyHappened = true;
				console.log(`geo.ready`, config);

				// Пересчитать размеры карты - ??? зачем? что оно делает?
				geoApi.updateMapSize();

				if (longValue && latValue) {
					console.log(`В БД есть первичные значения ШД:`, [longValue, latValue]);
					// -@ts-expect-error
					this.setSinglePoint();
				}

				// ОЦРВ сказали, что координаты по клику получаются только в системе 3857, конвертим сами
				geoApi.onMapClick = (coord, srCode) => {
					const coord3857 = epsg3857toEpsg4326(coord);
					console.log(`ШД клика: [${coord}] (${srCode}); либо [${coord3857}] (EPSG:4326)`);
					this.$data.longValue = coord3857[0];
					this.$data.latValue = coord3857[1];
					// -@ts-expect-error
					this.setSinglePoint(true);
				};
			}
		},
		/**
		 * Ставим на карте одну точку
		 * @param param0 координаты (долг,шир)
		 */
		setSinglePoint(doEmit: boolean = false) {
			const { latValue, longValue } = this.$data;
			if (!this.$data.geoReadyHappened) {
				console.log(`setSinglePoint вызван без geo ready, ничего не делаем`)
				return
			}
			const { geoApi } = this.$data;
			console.log(`Ставим точку ${[longValue, latValue]} с удалением предыдущей`);

			geoApi.getZoom((lastZoom) => {
				geoApi.clearGeometry();
				geoApi.showGeometry(
					{
						type: 'FeatureCollection',
						features: [
							{
								type: 'Feature',
								geometry: { type: 'Point', coordinates: [longValue, latValue] },
								properties: { prop0: 'value0' },
							}
						],
						// crs: { type: 'name', 'properties': { name: 'urn:ogc:def:crs:EPSG::4326' } }
					} /* 'new_style0041', true // TODO создать и указать стиль в цветах РЖД, поиграть с true (редакт.) */
				);
				// setZoom нужен, потому что showGeometry сбивает зум, приближая к точке
				geoApi.setZoom(lastZoom);
				if (doEmit) {
					// -@ts-expect-error
					this.emitValue([longValue, latValue]);
				}
			});
		},
		/**
		 * Отправляем новые данные "наверх" для сохранения
		 * @param longLat координаты обязательно в системе 4326 (типа, [37.617, 55.751])
		 */
		emitValue([long, lat]: Coords) {
			const fieldsToSet = {
				[this.$data.latDbcolname]: { newValue: lat },
				[this.$data.longDbcolname]: { newValue: long },
			};

			// -@ts-expect-error
			this.mixin_inputEvent({
				ctrlCode: this.$props.field_meta.ctrlCode,
				dbcolname: this.$props.field_meta.dbcolname,
				evtType: 'set',
				fieldsToSet,
			});
		},
	},
	mounted() {
		if (this.$props.view_type !== 'card') {
			this.mixin_errHandler(new Error(`Контрол реализован только для карточки`));
		}
	}
}
